import React from "react";

// componets
import AddCommunityButton from "./AddCommunityButton";

// assets
import EmptyCommunityImage from "bodycodi/cmap/app/img/empty_community_image_x2.png";

const EmptyCommunityPage = () => {
  return (
    <div className="empty-community-page">
      <img className="empty-community-img" src={EmptyCommunityImage} />
      <div className="title">
        커뮤니티에서 다양한 주제로
        <br />
        회원님과 소통해보세요!
      </div>
      <div className="desc">회원님께 먼저 글을 남겨보세요! 😊</div>
      <AddCommunityButton />
    </div>
  );
};

export default EmptyCommunityPage;
